import { db } from './firebase';
import { firestoreKeys } from '../utils/constants';

export default function useSupplierService() {
  const createSupplier = (supplierId, data) =>
    db.collection(firestoreKeys.SUPPLIERS).doc(supplierId).set(data, { merge: true });

  const updateSupplier = (supplierId, data) =>
    db.collection(firestoreKeys.SUPPLIERS).doc(supplierId).update(data);

  const getSupplier = (supplierId) => db.collection(firestoreKeys.SUPPLIERS).doc(supplierId).get();

  return {
    createSupplier,
    updateSupplier,
    getSupplier,
  };
}
